import { useState } from 'react';

import { getString } from '../../../../strings';
import { BigLoader, StyledBigLoader } from '../../../atoms/Loader/StyledBigLoader';
import { useQueryClient } from '@tanstack/react-query';
import { StyledAcceptCompetitorPopup } from './StyledAcceptCompetitorPopup.styles';
import PaymentsPopup from '../../../organisms/Payments/PaymentsPopup';
import { StyledText } from '../../../atoms/Text/StyledText';
import { StyledButton } from '../../../atoms/Button/StyledButton';
import { markRegistrationAsConfirmed } from '../../../../logic/requests/events';

const AcceptCompetitorPopup = ({ closePopup, player, eventId, canOnlyBeMarkedAsFree }) => {
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const onSubmit = (isFree) => {
        setError(null);
        setIsLoading(true);
        markRegistrationAsConfirmed(eventId, player.id, isFree)
            .then(() => {
                setIsLoading(false);
                queryClient.invalidateQueries(['eventPlayers', eventId]);
                closePopup();
            })
            .catch(() => {
                setIsLoading(false);
                setError(getString('tournament_playerElement_error_confirming_registration'));
            });
    };

    return (
        <PaymentsPopup>
            <>
                <StyledAcceptCompetitorPopup $isscrollbar={false}>
                    {error ? (
                        <StyledText
                            hasdeclaredfontsize="24px"
                            hasdeclaredfontweight="600"
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredfontcolor="#EE745C"
                            hasdeclaredtexttransform="uppercase"
                            hasdeclaredtextalign="center"
                            hasdeclaredmargin="0 0 15px 0"
                        >
                            {error}
                        </StyledText>
                    ) : null}
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding="20px 20px 0px 20px"
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {canOnlyBeMarkedAsFree ? (
                            <>
                                {getString('accept_competitor_popup_text3')} {player.firstname}{' '}
                                {player.lastname} {getString('accept_competitor_popup_text4')}?
                            </>
                        ) : (
                            <>
                                {getString('accept_competitor_popup_text1')} {player.firstname}{' '}
                                {player.lastname}? {getString('accept_competitor_popup_text2')}
                            </>
                        )}
                    </StyledText>
                    {isLoading ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <BigLoader />
                        </div>
                    ) : (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <StyledButton
                                    hasdeclaredfontcolor="#fff"
                                    hasdeclaredbgcolor="#6d85ba"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredcursor="pointer"
                                    hasdeclaredwidth="150px"
                                    hasdeclaredheight="50px"
                                    hasdeclaredfontsize="20px"
                                    hasdeclaredborderradius="35px"
                                    hasdeclaredmargin="20px 0 0 0"
                                    hasdeclaredfontweight="600"
                                    whileTap={{ scale: 0.9 }}
                                    whileHover={{ scale: 1.05 }}
                                    onClick={() => onSubmit(true)}
                                >
                                    {getString('send_email_popup_yes')}
                                </StyledButton>
                                {!canOnlyBeMarkedAsFree && (
                                    <StyledButton
                                        hasdeclaredfontcolor="#fff"
                                        hasdeclaredbgcolor="#6d85ba"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredcursor="pointer"
                                        hasdeclaredwidth="150px"
                                        hasdeclaredheight="50px"
                                        hasdeclaredfontsize="20px"
                                        hasdeclaredborderradius="35px"
                                        hasdeclaredmargin="20px 0 0 0"
                                        hasdeclaredfontweight="600"
                                        whileTap={{ scale: 0.9 }}
                                        whileHover={{ scale: 1.05 }}
                                        onClick={() => onSubmit(false)}
                                    >
                                        {getString('send_email_popup_no')}
                                    </StyledButton>
                                )}
                                {canOnlyBeMarkedAsFree && (
                                    <StyledButton
                                        hasdeclaredfontcolor="#fff"
                                        hasdeclaredbgcolor="#ee745c"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredcursor="pointer"
                                        hasdeclaredwidth="150px"
                                        hasdeclaredheight="50px"
                                        hasdeclaredfontsize="20px"
                                        hasdeclaredborderradius="35px"
                                        hasdeclaredmargin="20px 0 0 0"
                                        hasdeclaredfontweight="600"
                                        whileTap={{ scale: 0.9 }}
                                        whileHover={{ scale: 1.05 }}
                                        onClick={() => onSubmit(false)}
                                    >
                                        {getString('send_email_popup_cancel')}
                                    </StyledButton>
                                )}
                            </div>
                            {!canOnlyBeMarkedAsFree && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: '20px',
                                    }}
                                >
                                    <StyledButton
                                        hasdeclaredfontcolor="#fff"
                                        hasdeclaredbgcolor="#ee745c"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredcursor="pointer"
                                        hasdeclaredwidth="280px"
                                        hasdeclaredheight="50px"
                                        hasdeclaredfontsize="20px"
                                        hasdeclaredborderradius="35px"
                                        hasdeclaredmargin="20px 0 0 0"
                                        hasdeclaredfontweight="600"
                                        whileTap={{ scale: 0.9 }}
                                        whileHover={{ scale: 1.05 }}
                                        onClick={closePopup}
                                    >
                                        {getString('send_email_popup_cancel')}
                                    </StyledButton>
                                </div>
                            )}
                        </>
                    )}
                </StyledAcceptCompetitorPopup>
            </>
        </PaymentsPopup>
    );
};

export default AcceptCompetitorPopup;
